var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSelectMultiple(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6 4.99999L8 3H19.0001L21 4.99999V16.0001L19.0001 18H8L6 16.0001V4.99999ZM8 4.99999V16.0001H19.0001V4.99999H8Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.00001 21.9999L2 19.9999V9H4.00001V19.9999H13.4999V21.9999H4.00001ZM4.00007 18.9999L5.00006 19.9999H4.00001L4.00007 18.9999Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.2775 8.02897L17.015 6.71094L12.281 11.6531L9.98615 9.25737L8.72363 10.5754L12.281 14.2892L18.2775 8.02897Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSelectMultiple);
export default __webpack_public_path__ + "static/media/select-multiple.75133cc887e5ee0a7d90b041fb7d9db8.svg";
export { ForwardRef as ReactComponent };